import { VApp } from 'vuetify/lib/components/VApp';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"back",style:(this.$customStyle)},[_c('router-view'),_c(VOverlay,{attrs:{"value":_vm.carregando}},[_c(VProgressCircular,{attrs:{"size":80,"width":5,"color":"#BC0000","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }